import { z } from 'zod';

// ---- Update Link request ----

export const updateLinkRequestSchema = z.object({
    id: z.number().int(),
    locationTaskId: z.number().int().optional().nullable(),
    name: z.string(),
    url: z.string(),
    ordinal: z.number(),
    isActive: z.boolean(),
    baselineTaskLinkId: z.number().int().optional().nullable(),
    customerFileId: z.number().int().optional().nullable(),
    editingName: z.string().optional().nullable(),
    editingUrl: z.string().optional().nullable(),
});

export type UpdateLinkRequest = z.infer<typeof updateLinkRequestSchema>;

export const eligibleProjectSchema = z.object({
    projectLocationId: z.number().int(),
    projectName: z.string(),
    zeroDate: z.string(),
    earliestTaskDate: z.string(),
    currentDurationDays: z.number().int(),
});

export const eligibleProjectsResponseSchema = z.object({
    isFeatureEnabled: z.boolean(),
    projects: z.array(eligibleProjectSchema),
});

export const compressCommandSchema = z.object({
    locationId: z.number().int(),
    projectLocationIds: z.array(z.number().int()),
    newStartDate: z.string(),
});

export const compressResponseSchema = z.object({
    tasksUpdated: z.number().int(),
    oldDurationDays: z.number().int(),
    newDurationDays: z.number().int(),
});

export type EligibleProject = z.infer<typeof eligibleProjectSchema>;
export type EligibleProjectsResponse = z.infer<typeof eligibleProjectsResponseSchema>;
export type CompressCommand = z.infer<typeof compressCommandSchema>;
export type CompressResponse = z.infer<typeof compressResponseSchema>;
